import MyAccountChangePlanCard from './MyAccountChangePlanCard'

export default MyAccountChangePlanCard
// eslint-disable-next-line import/export
export * from './MyAccountChangePlanCard'
